// extracted by mini-css-extract-plugin
export default {"wrap":"DishProductsListModal_wrap__hI3l7","noData":"DishProductsListModal_noData__XAvcD"};